import { render, staticRenderFns } from "./SentenceChunk.vue?vue&type=template&id=a4175dec&scoped=true&"
import script from "./SentenceChunk.vue?vue&type=script&lang=js&"
export * from "./SentenceChunk.vue?vue&type=script&lang=js&"
import style0 from "./SentenceChunk.vue?vue&type=style&index=0&id=a4175dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4175dec",
  null
  
)

export default component.exports